import newTimesheetRecordDialogTemplate from './newTimesheetRecordDialog.html';
import newTimesheetRecordTemplate from './newTimesheetRecord.html';

const { startOfDay, isSameDay, set, addMinutes } = require('date-fns');

angular
   .module('org.saga.newtimesheetrecord', [
      'org.saga.service',
      'ui.timepicker',
      'ngMaterialDatePicker',
      'isolateForm'
   ])
   .filter('getLabel', [
      '$parse',
      function ($parse) {
         return function (item, labelExpression) {
            if (!labelExpression) {
               return item;
            }
            const parsedExpression = $parse(labelExpression);
            return parsedExpression({ item: item });
         };
      }
   ])
   .directive('newTimesheetRecord', [
      function () {
         return {
            restrict: 'E',
            template: newTimesheetRecordTemplate,
            scope: {
               newRecord: '=',
               minDate: '=',
               maxDate: '=',
               activities: '=',
               artifacts: '=',
               projects: '=',
               positions: '=',
               artifactLabelExpression: '=',
               activityLabelExpression: '=',
               projectLabelExpression: '=',
               positionLabelExpression: '=',
               error: '=',
               isEditing: '=',
               labels: '=',
               newRecordForm: '=',
            },
            controller: [
               '$scope',
               function ($scope) {
                  $scope.timepickerOptions = {
                     step: 15,
                     timeFormat: 'H:i'
                  };

                  $scope.timepickerEndOptions = angular.copy($scope.timepickerOptions);

                  function setLocalArtifacts(artifacts, projectId) {
                     const filteredArtifacts = artifacts.filter(
                        (artifact) => artifact.projectId[0].value === projectId
                     );
                     $scope.localArtifacts = filteredArtifacts;
                     setDefaultArtifact(filteredArtifacts);
                  }

                  function setDefaultArtifact(artifacts) {
                     if (artifacts.length === 1) {
                        $scope.newRecord.artifact = artifacts[0];
                     }
                  }

                  function setLocalPositions(positions, projectId) {
                     const filteredPositions = positions.reduce((acc, position) => {
                        const positionMpsvId = position.positionMpsvName[0].id;
                        const positionProjectsIds = position.projectId;
                        if (positionProjectsIds.some(p => p.value === projectId) && !acc.some((p) => p.positionMpsvName[0].id === positionMpsvId)) {
                           acc.push(position);
                        }
                        return acc;
                     }, []);
                     $scope.localPositions = filteredPositions;
                     setDefaultPosition(filteredPositions);
                  }

                  function setDefaultPosition(positions) {
                     if (positions.length === 1) {
                        $scope.newRecord.position = positions[0];
                     }
                  }

                  function setLocalActivitiesByPosition(activities, positionId) {
                     const filteredActivities = activities.filter((activity) =>
                        activity.positionMpsvId.find((e) => e.id === positionId)
                     );
                     $scope.activitiesLocal = filteredActivities;

                     setDefaultActivity($scope.activitiesLocal);
                  }

                  function setDefaultActivity(activities) {
                     if (activities.length === 1) {
                        $scope.newRecord.activity = activities[0];
                     }
                  }

                  function setDefaultProject(projects) {
                     if (projects.length === 1) {
                        $scope.newRecord.project = projects[0];
                        setLocalPositions($scope.positions, projects[0].id);
                        setLocalArtifacts($scope.artifacts, projects[0].id);
                     }
                  }

                  setDefaultProject($scope.projects);

                  $scope.$watch('newRecord.date', (val) => {
                     if (val) {
                        $scope.startOfSelectedDay = startOfDay($scope.newRecord.date);
                        $scope.endOfSelectedDay = set($scope.newRecord.date, {
                           hours: 23,
                           minutes: 45
                        });

                        if ($scope.newRecord.timeFrom) {
                           //in case of editing, we need to update the date of the start and end time
                           $scope.newRecord.timeFrom = new Date(
                              val.getFullYear(),
                              val.getMonth(),
                              val.getDate(),
                              $scope.newRecord.timeFrom.getHours(),
                              $scope.newRecord.timeFrom.getMinutes()
                           );
                           $scope.newRecordForm.newRecordTimeFrom.$setUntouched();
                        }
                     }
                  });

                  $scope.$watch('newRecord.timeFrom', (val) => {
                     $scope.error = false;
                     if (val) {
                        $scope.timepickerEndOptions = {
                           ...$scope.timepickerEndOptions,
                           minTime: addMinutes($scope.newRecord.timeFrom, 15),
                           maxTime: $scope.endOfSelectedDay
                        };
                        //in case of editing, we need to update the date of the end time
                        if ($scope.newRecord.timeTo && !isSameDay(val, $scope.newRecord.timeTo)) {
                           $scope.newRecord.timeTo = new Date(
                              val.getFullYear(),
                              val.getMonth(),
                              val.getDate(),
                              $scope.newRecord.timeTo.getHours(),
                              $scope.newRecord.timeTo.getMinutes()
                           );
                           $scope.newRecordForm.newRecordTimeTo.$setUntouched();
                        }
                     }
                  });

                  function isObjectEmpty(obj) {
                     return Object.keys(obj).length === 0;
                  }

                  $scope.$watch('newRecord.project', (val) => {
                     if (val && !isObjectEmpty(val)) {
                        if (!$scope.isEditing) {
                           $scope.newRecord.position = undefined;
                           $scope.newRecord.artifact = undefined;
                           $scope.newRecord.activity = undefined;
                        }
                        setLocalPositions($scope.positions, val.projectId);
                        setLocalArtifacts($scope.artifacts, val.projectId);
                     }
                  });

                  $scope.$watch('newRecord.position', (val) => {
                     if (val && !isObjectEmpty(val)) {
                        if (!$scope.isEditing) {
                           $scope.newRecord.activity = undefined;
                        }
                        $scope.isEditing = false;
                        setLocalActivitiesByPosition($scope.activities, val.positionMpsvName[0].id);
                     }
                  });
               }
            ]
         };
      }
   ])

   .factory('NewTimesheetRecordDialog', [
      '$mdDialog',
      '$log',
      function ($mdDialog, $log) {
         return {
            show: function (
               activityLabelExpression,
               activities,
               artifactLabelExpression,
               artifacts,
               labels,
               maxDateObject,
               minDateObject,
               positionLabelExpression,
               positions,
               projectLabelExpression,
               projects,
               record,
               records,
               isEditing,
               callback
            ) {
               function DialogController($scope, $log, $mdDialog) {
                  $scope.record = record;
                  $scope.minDate = minDateObject;
                  $scope.maxDate = maxDateObject;
                  $scope.activities = activities;
                  $scope.artifacts = artifacts;
                  $scope.projects = projects;
                  $scope.positions = positions;
                  $scope.activityLabelExpression = activityLabelExpression;
                  $scope.artifactLabelExpression = artifactLabelExpression;
                  $scope.projectLabelExpression = projectLabelExpression;
                  $scope.positionLabelExpression = positionLabelExpression;
                  $scope.labels = labels;
                  $scope.isEditing = isEditing;
                  $scope.cancel = function () {
                     $mdDialog.cancel();
                  };

                  const checkRecordIntervalOverlap = (newRecord) =>
                     records.some((rec) => {
                        const recStartTime = new Date(rec.timeFrom);
                        const recEndTime = new Date(rec.timeTo);
                        return (
                           (newRecord.timeFrom <= recStartTime &&
                              newRecord.timeTo > recStartTime) ||
                           (newRecord.timeFrom < recEndTime && newRecord.timeTo >= recEndTime) ||
                           (newRecord.timeFrom >= recStartTime && newRecord.timeTo <= recEndTime)
                        );
                     });

                  $scope.ok = function () {
                     $scope.error = false;
                     const recordIntervalOverlap = checkRecordIntervalOverlap(record);

                     if (recordIntervalOverlap) {
                        $scope.error = true;
                     } else {
                        $mdDialog.hide($scope.record);
                     }
                  };
               }

               $mdDialog
                  .show({
                     controller: ['$scope', '$log', '$mdDialog', DialogController],
                     template: newTimesheetRecordDialogTemplate,
                     parent: angular.element(document.body),
                     clickOutsideToClose: false
                  })
                  .then(
                     function (answer) {
                        callback(answer);
                     },
                     function () {
                        // callback is not called
                     }
                  );
            }
         };
      }
   ]);
